/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'slide {positionInSet} de {setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Adicionar um título',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Pausar',
  'company-hub.carousel-extension.carousel-navigation.play': 'Reproduzir',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Avançar',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Anterior',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Adicionar quadro',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Adicionar quadros',
  'company-hub.carousel-extension.config-panel.layout.title': 'Escolha um layout',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': 'Texto com moldura acima da imagem',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Plano de fundo com cor sólida',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Design dividido',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Link',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'ATUALIZADO',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': 'Ícones de círculos indicando o progresso',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Miniaturas',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'Saiba mais sobre carrosséis',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    'Crie um conjunto de até {number} imagens giratórias. {supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    'Crie um conjunto de até {number} imagens giratórias.',
  'company-hub.carousel-extension.config-panel.style.general.title': 'Geral',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navegação',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Reprodução automática',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    'Configure seu carrossel para rolar por conta própria a cada {number} segundos no modo de visualização',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Conteúdo',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Estilos',
  'company-hub.carousel-extension.config-panel.title': 'Carrossel',
  'company-hub.carousel-extension.description.field.label': 'Descrição',
  'company-hub.carousel-extension.description.placeholder': 'Personalize este quadro para criar o carrossel.',
  'company-hub.carousel-extension.frame-spotlight.label': 'moldura {positionInSet} de {setSize}',
  'company-hub.carousel-extension.frame.background.color': 'Cor do plano de fundo',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Suas cores de texto e plano de fundo não facilitam a leitura.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'As cores do texto e do plano de fundo facilitam a leitura.',
  'company-hub.carousel-extension.frame.text.color': 'Cor do texto',
  'company-hub.carousel-extension.hub-element.description': 'Um carrossel com lindas molduras',
  'company-hub.carousel-extension.hub-element.title': 'Carrossel',
  'company-hub.carousel-extension.manifest.macro-description': 'Criar um trio rotativo de quadros dinâmicos.',
  'company-hub.carousel-extension.manifest.macro-title': 'Carrossel',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Carrossel [Atualizado]',
  'company-hub.carousel-extension.placeholder.description': 'Personalize este quadro para criar o carrossel.',
  'company-hub.carousel-extension.placeholder.title': 'Dê um título ao quadro',
  'company-hub.carousel-extension.recommended.field.label': '(Recomendado)',
  'company-hub.carousel-extension.title.field.label': 'Cargo',
  'company-hub.carousel-extension.title.placeholder': 'Dê um título ao quadro',
};
